import React, { useContext } from 'react'
import { Popover } from '@material-ui/core'
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import myContext from '../../FiltersComponent/context/context'

// function SelectSearchType() {
const PreSearchFilter = () => {
    const { preSearchCriteria, setPreSearchCriteria, savedSearch } = useContext(myContext)
    const [anchorEl, setAnchorEl] = React.useState(null)
    // const [isProspecting, setisProspecting] = useState(false)

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleClick = event => {
        if (preSearchCriteria.searchType !== 'prospecting') {
            setAnchorEl(event.currentTarget)
        }
    }

    const isdisabled = () => {
        let returnVal = false

        const index = savedSearch.findIndex(x => x.isTargetMarket)

        returnVal = index === -1 ? true : false

        return returnVal
    }

    const open = Boolean(anchorEl)

    return (
        <>
            <div className="px-2">
                <a data-testid="button-PreSearchFilter" onClick={handleClick} className={preSearchCriteria.searchType === 'prospecting' ? 'c-disabled' : 'cursor-pointer'}>
                    <ExpandMoreIcon ></ExpandMoreIcon>
                </a>

                {/* <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-auto" transform="rotate(180)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M12 8.30849L20.7197 17.0274C21.0126 17.3203 21.4875 17.3202 21.7804 17.0273C22.0732 16.7344 22.0732 16.2595 21.7803 15.9667L12.9665 7.15366C12.8397 7.02668 12.6889 6.92583 12.5231 6.85708C12.3573 6.78832 12.1795 6.75293 12 6.75293C11.8205 6.75293 11.6427 6.78832 11.4769 6.85708C11.3111 6.92583 11.1605 7.02657 11.0336 7.15355L2.21969 15.9667C1.92679 16.2595 1.92677 16.7344 2.21965 17.0273C2.51252 17.3202 2.9874 17.3203 3.28031 17.0274L12 8.30849Z" fill="black" />
                </svg> */}
                <Popover data-testid="popover-PreSearchFilter" open={open} anchorEl={anchorEl} onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }} >
                    <div className="flex flex-col p-4 space-y-4 mr-4" >
                        <div>
                            <input data-testid="chk-Search-target-market" disabled={isdisabled()} onChange={() => setPreSearchCriteria({ ...preSearchCriteria, isSearchTargetMarket: !preSearchCriteria.isSearchTargetMarket })} checked={preSearchCriteria.isSearchTargetMarket} type="checkbox" id="chk-Search-target-market" name="chk-Search-target-market" value="false" />
                            <label data-testid="lbl-Search-target-market" htmlFor="chk-Search-target-market" className="px-4">Target Market</label>
                            {isdisabled() ?
                                <div className="pb-2 text-danger">
                                    <small>Save a search as target market first</small>
                                </div>
                                : null}
                        </div>
                        <div>
                            <input data-testid="chk-prior-name" onChange={() => setPreSearchCriteria({ ...preSearchCriteria, isPriorName: !preSearchCriteria.isPriorName })} checked={preSearchCriteria.isPriorName} type="checkbox" id="chk-prior-name" name="chk-prior-name" value="false" />
                            <label data-testid="lbl-prior-name" htmlFor="chk-prior-name" className="px-4">Prior Name</label>
                        </div>
                    </div>
                </Popover>
            </div>
        </>
    )
}

export default PreSearchFilter
